export default __webpack_public_path__ + "static/media/lockIcon.81c4232d.svg";